import { Portal } from '@l2p/apps-shared'
import React from 'react'
import ModalComponent from './ModalComponent'
export { ModalTitle } from './ModalTitle'

export interface ModalProps {
  width: string
  height?: string
  portalNodeId?: string
  onClose?: () => void
  padding?: string
  children?: React.ReactNode
  id?: string
  className?: string
  closeIconClassName?: string
  showClose?: boolean
  bgColor?: string
  saveSize?: boolean
  overflowY?: string
  closeOnlyOnCross?: boolean
  style?: any
}

const Modal: React.FC<ModalProps> = ({
  portalNodeId = 'modal',
  showClose = true,
  bgColor,
  ...props
}) => {
  return (
    <Portal portalNode={portalNodeId}>
      <ModalComponent showClose={showClose} bgColor={bgColor} {...props} />
    </Portal>
  )
}

export default Modal
